import { SvgIconProps, Tooltip } from "@mui/material";
import { PersonAddAlt } from "@mui/icons-material";
import { ProductUnion } from "../../../types/ProductUnion";

type CaseAdditionalClientsTooltipIconProps = {
  product: ProductUnion;
  fontSize?: SvgIconProps["fontSize"];
};
export default function CaseAdditionalClientsTooltipIcon({ product, fontSize = "medium" }: CaseAdditionalClientsTooltipIconProps) {
  if (!product.additionalClients.length) {
    return null;
  }

  return (
    <Tooltip title={`Weitere Mandantschaft: ${product.additionalClients.map((client) => client.fullName).join(", ")}`}>
      <PersonAddAlt sx={{ color: "primary.main" }} fontSize={fontSize} />
    </Tooltip>
  );
}
